import React from 'react'
import PropTypes from 'prop-types'
import { FieldGroup } from 'components/FieldGroup'

export const InputField = ({ input, id, type, label, placeholder }) => {
	return <FieldGroup
		id={id}
		type={type}
		label={label}
		placeholder={placeholder}
		{...input}
	/>

}

InputField.propTypes = {
	input: PropTypes.object,
	id: PropTypes.string,
	type: PropTypes.string,
	label: PropTypes.string,
	placeholder: PropTypes.string
}

export default InputField



// WEBPACK FOOTER //
// ./src/components/InputField.js